<mat-card appearance="outlined" class="mb-10 col-sm-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
    <mat-card-header>
        <mat-card-title>
            <mat-icon>settings</mat-icon> Settings
        </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <br/>
      <h1>Extension Categories</h1>
      <mat-chip-set>
        <app-button-tag
              class="m-1"
              (itemClick)="updateCategory(cat.id)"
              *ngFor="let cat of dataService.categories | async"
              [label]="cat.name"
              [icon]="cat.icon"
              [color]="cat.color"
              [style]="cat.archived ? 'opacity: 0.2;' : ''"
        >
        </app-button-tag>
      </mat-chip-set>
      <br/><br/>
      <button mat-raised-button color="primary" (click)="updateCategory(-1)">
        <mat-icon>add</mat-icon> &nbsp;Add new
      </button>

      <br/><br>
      <mat-divider></mat-divider>
      <br/>

      <h1>Extension Activities</h1>
      <mat-chip-set>
        <ng-container *ngFor="let activityType of (dataService.activityTypes | async) as items; let i = index;">
          <ng-container *ngIf="i === 0 || activityType.category !== items[i-1].category">

            <h2 style="display: block; width: 100%; margin: 0;" [style.marginTop]="i === 0 ? 0 : '10px'">{{ (activityType.category | resolveCategory).name }}</h2>
          </ng-container>
          <app-button-tag
            class="m-1"
            (itemClick)="updateActivity(activityType.id)"
            [label]="activityType.name"
            [icon]="(activityType.category | resolveCategory).icon"
            [color]="(activityType.category | resolveCategory).color"
            [style]="activityType.archived ? 'opacity: 0.2;' : ''"
          ></app-button-tag>
        </ng-container>
      </mat-chip-set>
      <br/><br/>
      <button mat-raised-button color="primary" (click)="updateActivity(-1)">
        <mat-icon>add</mat-icon> &nbsp;Add new
      </button>

      <br/><br>
      <mat-divider></mat-divider>
      <br/>

      <h1>Assistance Types</h1>
      <mat-chip-set>
        <ng-container *ngFor="let assistanceType of (dataService.assistanceProvidedTypes | async) as items; let i = index;">
          <ng-container *ngIf="i === 0 || assistanceType.category !== items[i-1].category">

            <h2 style="display: block; width: 100%; margin: 0;" [style.marginTop]="i === 0 ? 0 : '10px'">{{ (assistanceType.category | resolveCategory).name }}</h2>
          </ng-container>
          <app-button-tag
            class="m-1"
            (itemClick)="updateAssistanceType(assistanceType.id)"
            [label]="assistanceType.name"
            [icon]="(assistanceType.category | resolveCategory).icon"
            [color]="(assistanceType.category | resolveCategory).color"
          ></app-button-tag>
        </ng-container>
      </mat-chip-set>
      <br/><br/>
      <button mat-raised-button color="primary" (click)="updateAssistanceType(-1)">
        <mat-icon>add</mat-icon> &nbsp;Add new
      </button>

      <br/><br>
      <mat-divider></mat-divider>
      <br/>

      <h1>Risk Types</h1>
      <mat-chip-set>
        <ng-container *ngFor="let riskType of (dataService.riskAddressedTypes | async) as items; let i = index;">
          <ng-container *ngIf="i === 0 || riskType.category !== items[i-1].category">

            <h2 style="display: block; width: 100%; margin: 0;" [style.marginTop]="i === 0 ? 0 : '10px'">{{ (riskType.category | resolveCategory).name }}</h2>
          </ng-container>
          <app-button-tag
            class="m-1"
            (itemClick)="updateRiskType(riskType.id)"
            [label]="riskType.name"
            [icon]="(riskType.category | resolveCategory).icon"
            [color]="(riskType.category | resolveCategory).color"
          ></app-button-tag>
        </ng-container>
      </mat-chip-set>
      <br/><br/>
      <button mat-raised-button color="primary" (click)="updateRiskType(-1)">
        <mat-icon>add</mat-icon> &nbsp;Add new
      </button>

      <br/><br>
      <mat-divider></mat-divider>
      <br/>

      <h1>Practice Change Activities</h1>
      <mat-chip-set>
        <ng-container *ngFor="let practiceChangeActivity of (dataService.practiceChangeActivities | async) as items; let i = index;">
          <ng-container *ngIf="i === 0 || practiceChangeActivity.category !== items[i-1].category">

            <h2 style="display: block; width: 100%; margin: 0;" [style.marginTop]="i === 0 ? 0 : '10px'">{{ (practiceChangeActivity.category | resolveCategory).name }}</h2>
          </ng-container>
          <app-button-tag
            class="m-1"
            (itemClick)="updatePracticeChangeActivity(practiceChangeActivity.id)"
            [label]="practiceChangeActivity.name"
            [icon]="(practiceChangeActivity.category | resolveCategory).icon"
            [color]="(practiceChangeActivity.category | resolveCategory).color"
          ></app-button-tag>
        </ng-container>
      </mat-chip-set>
      <br/><br/>
      <button mat-raised-button color="primary" (click)="updatePracticeChangeActivity(-1)">
        <mat-icon>add</mat-icon> &nbsp;Add new
      </button>

      <br/><br>
      <mat-divider></mat-divider>
      <br/>

      <h1>Sync with Hort360</h1>
      <p>Pull update information across from Hort360. This process is automatic and occurs every ~6 hours, however you can manually force an update if information required is missing (i.e. new user has been added to Hort360).</p>
      <button mat-raised-button color="primary" (click)="syncHort360()">
        <mat-icon>sync</mat-icon> &nbsp;Synchronise now
      </button>

    </mat-card-content>
</mat-card>
